import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import SummaryProjectApprovalSenceStaffWidget from '../../../widgets/summaryProjectApprovalSenceStaffWidget/SummaryProjectApprovalSenceStaffWidget'

export default function SummaryProjectApprovalSenceStaff() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const mockSchema = {
    header: 'สรุปผลการพิจารณาอนุมัติโครงการ',
    subHeader: '',
    summaryProject: {
      header: 'ผลพิจารณาอนุมัติ',
      buttonText: 'บันทึกผลพิจารณาอนุมัติโครงการ',
      inputSummaryProject: {
        name: 'summaryProject',
        label: 'ผลพิจารณาอนุมัติ',
        placeholder: 'ระบุผลพิจารณาอนุมัติ',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            errorMessage: 'กรุณาระบุผลพิจารณาอนุมัติ',
          },
        ],
      },
    },
  }

  const handleGetSchema = async (proposalId) => {
    setSchema(mockSchema)
  }

  useEffect(() => {
    console.log('load ProjectName projectId', projectId)

    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal statusDefault={8}>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <SummaryProjectApprovalSenceStaffWidget
            showCommandButton={true}
            schema={schema.summaryProject}
          />
        </SidebarProposal>
      )}
    </>
  )
}
